module.exports = __webpack_public_path__ + "img/img4.4b7fd577.jpg";